import {
  useStreetNumberInputState,
  useUnitNumberInputState,
  useStreetNameInputState,
  useCityInputState,
  useProvinceInputState,
  usePostalCodeInputState
} from './';

export function useAddressState(initialAddress = {}, options = {}) {
  const {
    streetNumber: initialStreetNumber,
    unitNumber: initialUnitNumber,
    streetName: initialStreetName,
    city: initialCity,
    province: initialProvince,
    postalCode: initialPostalCode
  } = initialAddress;

  const {
    value: streetNumber,
    setValue: setStreetNumber,
    validateValue: validateStreetNumber,
    error: streetNumberError,
    resetValue: resetStreetNumber,
    setError: setStreetNumberError
  } = useStreetNumberInputState({
    initialValue: initialStreetNumber || '',
    ...options
  });

  const {
    value: unitNumber,
    setValue: setUnitNumber,
    resetValue: resetUnitNumber,
    setError: setUnitNumberError
  } = useUnitNumberInputState({
    initialValue: initialUnitNumber || '',
    ...options
  });

  const {
    value: streetName,
    setValue: setStreetName,
    validateValue: validateStreetName,
    error: streetNameError,
    resetValue: resetStreetName,
    setError: setStreetNameError
  } = useStreetNameInputState({
    initialValue: initialStreetName || '',
    ...options
  });

  const {
    value: city,
    setValue: setCity,
    validateValue: validateCity,
    error: cityError,
    resetValue: resetCity,
    setError: setCityError
  } = useCityInputState({
    initialValue: initialCity || '',
    ...options
  });

  const {
    value: province,
    setValue: setProvince,
    validateValue: validateProvince,
    error: provinceError,
    resetValue: resetProvince,
    setError: setProvinceError
  } = useProvinceInputState({
    initialValue: initialProvince || '',
    ...options
  });

  const {
    value: postalCode,
    setValue: setPostalCode,
    validateValue: validatePostalCode,
    error: postalCodeError,
    resetValue: resetPostalCode,
    setError: setPostalCodeError
  } = usePostalCodeInputState({
    initialValue: initialPostalCode || '',
    ...options
  });

  function getAllFields() {
    return {
      address: {
        streetNumber,
        unitNumber,
        streetName,
        city,
        province,
        postalCode
      }
    };
  }

  function validateAllFields() {
    return Promise.all([
      validateStreetNumber(),
      validateStreetName(),
      validateCity(),
      validateProvince(),
      validatePostalCode()
    ]).then((results) => {
      const isValid = !results.some((isValid) => !isValid);
      return isValid;
    });
  }

  function resetAllFields() {
    resetStreetNumber('');
    resetStreetName('');
    resetCity('');
    resetProvince('');
    resetPostalCode('');
  }

  function resetAllErrors() {
    setStreetNumberError('');
    setStreetNameError('');
    setCityError('');
    setProvinceError('');
    setPostalCodeError('');
    setUnitNumberError('');
  }

  return {
    streetNumber,
    setStreetNumber,
    validateStreetNumber,
    streetNumberError,
    resetStreetNumber,
    setStreetNumberError,
    unitNumber,
    setUnitNumber,
    resetUnitNumber,
    setUnitNumberError,
    streetName,
    setStreetName,
    validateStreetName,
    streetNameError,
    resetStreetName,
    setStreetNameError,
    city,
    setCity,
    validateCity,
    cityError,
    resetCity,
    setCityError,
    province,
    setProvince,
    validateProvince,
    provinceError,
    resetProvince,
    setProvinceError,
    postalCode,
    setPostalCode,
    validatePostalCode,
    postalCodeError,
    resetPostalCode,
    setPostalCodeError,
    getAllFields,
    validateAllFields,
    resetAllErrors,
    resetAllFields
  };
}
